import React from 'react';
import EditForm from '../components/EditForm';
import SingleRecordWorkspace from '../components/ui/SingleRecordWorkspace';
import NotificationSnackbar from '../components/ui/NotificationSnackbar';
import useLeadForm from '../hooks/useLeadForm';
import { SaveOutlined } from '@mui/icons-material';

const NewLead = () => {
  const initialLeadData = {
    first_name: '', last_name: '', email: '', phone_number: '', company_name: '', lead_status: 'new',
    contact_name: '', priority: 'medium', follow_up_date: '', assigned_salesperson: '', hotness: 1,
    amount: 0, notes: '', gst_number: '', user: 'default_user',
  };

  const {
    leadData, customFields, notification, activeTab, handleChange, handleCustomFieldsUpdate,
    handleSubmit, handleCloseNotification, setActiveTab,
  } = useLeadForm(initialLeadData);

  const submit = () => handleSubmit({ preventDefault: () => {} });
  const cards = [
    {
      id: 'contact-actions', title: 'Actions', position: 'right', fixed: true, disableDrag: true,
      deletable: false, allowSettings: false, titleEditable: false, fieldKeys: [],
      customContent: () => <div className="record-action-buttons"><button type="button" className="hs-listing__create" title="Create contact" aria-label="Create contact" onClick={submit}><SaveOutlined /></button></div>,
    },
    {
      id: 'contact-related-documents', title: 'Related Documents', position: 'right', deletable: false, editable: false, fieldKeys: [],
      customContent: () => <div className="record-related-documents"><small>Quotations, work orders, proforma invoices and invoices will appear after this contact is created.</small></div>,
    },
  ];

  return <>
    <SingleRecordWorkspace
      storageKey="jdh-crm:record:lead:new"
      backTo="/leads"
      backLabel="Contacts"
      title="New contact"
      subtitle="Create a new contact"
      record={leadData}
      fields={[]}
      initialCards={cards}
      summaryCard={{ backTo: '/leads', backLabel: 'Contacts', displayTitle: 'New contact', subtitle: 'Create a new contact', editable: false }}
      hidePageHeader
      centerLabel={null}
      centerContent={<EditForm leadData={leadData} handleChange={handleChange} handleSubmit={handleSubmit} customFields={customFields} handleCustomFieldsUpdate={handleCustomFieldsUpdate} activeTab={activeTab} setActiveTab={setActiveTab} hideActions />}
    />
    <NotificationSnackbar open={notification.open} message={notification.message} severity={notification.severity} onClose={handleCloseNotification} />
  </>;
};

export default NewLead;
